import styled from '@emotion/styled'

export const Item = styled.div`
  display: grid;
  grid-template-columns: 120px auto 50px 50px;
`

export const ButtonContainer = styled.div`
  padding: 20px 10px;
`
